import DestiniLocator from "./DestiniLocator";

export { DestiniLocator };

export default DestiniLocator;
